import React, { useState, useEffect, useRef } from 'react';
import { Container, Title, Switch, Button, Dialog } from "@bsf/force-ui";
import apiFetch from '@wordpress/api-fetch';
import { __ , sprintf } from '@wordpress/i18n';

const VersionControl = () => {
    const [betaEnabled, setBetaEnabled] = useState(false);
    const licenseStatus = uaelSettingsData.license_status;
    const previousAddonVersions = uaelSettingsData.uael_versions;
    const previousLiteVersions = uaelSettingsData.uaelite_versions;

    const proVersionRef = useRef(previousAddonVersions[0].value);
    const liteVersionRef = useRef(previousLiteVersions ? previousLiteVersions[0].value : '');

    const [previousVersionSelect, setPreviousVersion] = useState(previousAddonVersions[0].value);
    const [liteVersionSelect, setLiteVersionSelect] = useState(previousLiteVersions ? previousLiteVersions[0].value : '');
    const [productSelect, setProductSelect] = useState('uael');
    const [freeproductSelect, setFreeproductSelect] = useState('elementor-header-footer');

    const [openPopup, setOpenPopup] = useState(false);
    const [openLitePopup, setOpenLitePopup] = useState(false);

    // Set default value when the component mounts.
    useEffect(() => {
        setBetaEnabled('enable' === uaelSettingsData.beta_enabled);
    }, [openPopup, openLitePopup]);

    const rollbackClickHandler = () => {
        setPreviousVersion(proVersionRef.current.value);
        setProductSelect('uael');
        setOpenPopup(true);
    };

    const handleBetaSwitch = (event) => {
        const allow_beta = event ? 'enable' : 'disable';

        // Update the state of the Switch
        setBetaEnabled(event);

        // AJAX call to save the new value
        const formData = new window.FormData();
        formData.append('allow_beta', allow_beta); // Append allow_beta
        formData.append('action', 'uael_allow_beta_updates'); // Append action
        formData.append('nonce', uaelSettingsData.ajax_nonce); // Append nonce

        apiFetch({
            url: uaelSettingsData.ajax_url,
            method: 'POST',
            body: formData,
        }).then((data) => {
            if (data.success) {
                // console.log("Beta status updated");
            } else {
                setBetaEnabled(!event); // Revert to previous state
            }
        }).catch((error) => {
            setBetaEnabled(!event); // Revert to previous state
        });
    };

    const onCancelClick = () => {
        setOpenPopup(false);
    };

    const onContinueClick = () => {
        const rollbackUrl = uaelSettingsData.uael_rollback_url.replace(
            'VERSION',
            previousVersionSelect
        );
        setOpenPopup(false);
        window.location.href = rollbackUrl;
    };

    const onLiteCancelClick = () => {
        setOpenLitePopup(false);
    };

    const onLiteContinueClick = () => {
        const rollbackUrl = uaelSettingsData.uaelite_rollback_url.replace(
            'VERSION',
            liteVersionSelect
        );
        setOpenLitePopup(false);
        window.location.href = rollbackUrl;
    };

    const handleVersionChange = (event) => {
        setPreviousVersion(event.target.value);
    }

    const handleLiteVersionChange = (event) => {
        setLiteVersionSelect(event.target.value);
    }

    return (
        <>
            <Title
                description=""
                icon={null}
                iconPosition="right"
                size="sm"
                tag="h2"
                title={__('Version Control', 'uael')}
            />
            <div
                className="box-border bg-background-primary p-6 rounded-lg"
                style={{
                    marginTop: "24px",
                }}
            >
                {uaelSettingsData.is_lite_active && (
                    <>
                        <Container
                            align="stretch"
                            className="flex flex-col lg:flex-row"
                            containerType="flex"
                            direction="column"
                            gap="sm"
                            justify="start"
                        >
                            <Container.Item className="shrink flex flex-col space-y-1">
                                <p className="text-base font-semibold m-0">
                                    {sprintf(
                                        __('Rollback %s to Previous Version', 'uael'),
                                        uaelSettingsData.plugin_short_name
                                    )}
                                </p>
                                <p className="text-sm font-normal m-0">
                                    {__('Experiencing an issue with current version? Roll back to a previous version to help troubleshoot the issue.', 'uael')}
                                </p>
                            </Container.Item>
                            <Container.Item
                                className="p-2 flex space-y-4"
                                alignSelf="auto"
                                order="none"
                            >
                                <div className="bsf-rollback-version">
                                    <input type="hidden" name="product-name" id="bsf-product-name" value={'uael'} />
                                    <select
                                        id="uaeliteVersionRollback"
                                        ref={liteVersionRef}
                                        onBlur={() => {
                                            setFreeproductSelect('elementor-header-footer');
                                        }}
                                        onChange={handleLiteVersionChange}
                                        style={{
                                            padding: '8px',
                                            marginRight: '10px',
                                            marginTop: '16px',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            height: '44px',
                                            width: '100px',
                                        }}
                                    >
                                        {previousLiteVersions.map((version) => (
                                            <option key={version.value} value={version.value}>
                                                {version.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex flex-col cursor-pointer">
                                    <Dialog
                                        design="simple"
                                        exitOnEsc
                                        scrollLock
                                        open={openLitePopup} // Ensure Dialog is controlled by state
                                        setOpen={setOpenLitePopup} // Synchronize state
                                        trigger={<Button style={{ backgroundColor: '#6005ff' }} >{__('Rollback', 'uael')}</Button>}
                                    >
                                        <Dialog.Backdrop />
                                        <Dialog.Panel>
                                            <Dialog.Header>
                                                <div className="flex items-center justify-between">
                                                    <Dialog.Title>
                                                        {__('Rollback to Previous Version', 'uael')}
                                                    </Dialog.Title>
                                                    <Dialog.CloseButton />
                                                </div>
                                            </Dialog.Header>
                                            <Dialog.Body>
                                                {sprintf(
                                                    __('Are you sure you want to rollback to %s v%s?', 'uael'),
                                                    uaelSettingsData.plugin_short_name,
                                                    liteVersionSelect
                                                )}
                                            </Dialog.Body>
                                            <Dialog.Footer>
                                                <Button style={{ backgroundColor: '#6005ff' }} onClick={onLiteContinueClick}>
                                                    {__('Rollback', 'uael')}
                                                </Button>
                                                <Button style={{ backgroundColor: '#6005ff' }} onClick={onLiteCancelClick}>
                                                    {__('Cancel', 'uael')}
                                                </Button>
                                            </Dialog.Footer>
                                        </Dialog.Panel>
                                    </Dialog>
                                </div>
                            </Container.Item>
                        </Container>
                        <div
                            className="border border-subtle"
                            style={{
                                height: '2px',
                                backgroundColor: '#E5E7EB',
                                marginTop: '16px',
                                marginBottom: '16px',
                            }}
                        />
                    </>
                )}
                {licenseStatus && (
                    <>
                        <Container
                            align="stretch"
                            className="flex flex-col lg:flex-row"
                            containerType="flex"
                            direction="column"
                            gap="sm"
                            justify="start"
                        >
                            <Container.Item className="shrink flex flex-col space-y-1">
                                <p className="text-base font-semibold m-0">
                                    {sprintf(
                                        __('Rollback %s Pro to Previous Version', 'uael'),
                                        uaelSettingsData.plugin_short_name
                                    )}
                                </p>
                                <p className="text-sm font-normal m-0">
                                    {__('Experiencing an issue with current version? Roll back to a previous version to help troubleshoot the issue.', 'uael')}
                                </p>
                            </Container.Item>
                            <Container.Item
                                className="p-2 flex space-y-4"
                                alignSelf="auto"
                                order="none"
                            >
                                <div className="bsf-rollback-version">
                                    <input type="hidden" name="product-name" id="bsf-product-name" value={'uael'} />
                                    <select
                                        id="uaelVersionRollback"
                                        ref={proVersionRef}
                                        onBlur={(e) => {
                                            setProductSelect('uael');
                                            e.target.style.borderColor = '#e0e0e0'; 
                                        }}
                                        onChange={handleVersionChange}
                                        style={{
                                            padding: '8px',
                                            marginRight: '10px',
                                            marginTop: '16px',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            height: '40px',
                                            width: '100px',
                                            borderColor: '#e0e0e0', // Default border color
                                            outline: 'none',       // Removes the default outline
                                            boxShadow: 'none',
                                            // marginTop: '16px'     // Removes the default box shadow
                                        }}
                                        onFocus={(e) => e.target.style.borderColor = '#6005FF'} // Apply focus color
                                    >
                                        {previousAddonVersions.map((version) => (
                                            <option key={version.value} value={version.value}>
                                                {version.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex flex-col cursor-pointer">
                                    <Dialog
                                        design="simple"
                                        exitOnEsc
                                        scrollLock
                                        open={openPopup} // Ensure Dialog is controlled by state
                                        setOpen={setOpenPopup} // Synchronize state
                                        trigger={<Button style={{ backgroundColor: '#6005ff' }}>{__('Rollback', 'uael')}</Button>}
                                    >
                                        <Dialog.Backdrop />
                                        <Dialog.Panel>
                                            <Dialog.Header>
                                                <div className="flex items-center justify-between">
                                                    <Dialog.Title>
                                                        {__('Rollback to Previous Version', 'uael')}
                                                    </Dialog.Title>
                                                    <Dialog.CloseButton />
                                                </div>
                                            </Dialog.Header>
                                            <Dialog.Body>
                                                {__(`Are you sure you want to rollback to ${uaelSettingsData.plugin_name} v${previousVersionSelect}?`, 'uael')}
                                            </Dialog.Body>
                                            <Dialog.Footer>
                                                <Button onClick={onContinueClick} style={{ backgroundColor: '#6005ff' }}>
                                                    {__('Rollback', 'uael')}
                                                </Button>
                                                <Button onClick={onCancelClick} style={{ backgroundColor: '#6005ff' }}>
                                                    {__('Cancel', 'uael')}
                                                </Button>
                                            </Dialog.Footer>
                                        </Dialog.Panel>
                                    </Dialog>
                                </div>
                            </Container.Item>
                        </Container>
                        <div
                            className="border border-subtle"
                            style={{
                                height: '2px',
                                backgroundColor: '#E5E7EB',
                                marginTop: '16px',
                                marginBottom: '16px',
                            }}
                        />
                    </>
                )}
                <Container
                    align="stretch"
                    className="flex flex-col lg:flex-row"
                    containerType="flex"
                    direction="column"
                    gap="sm"
                    justify="start"
                >
                    <Container.Item className="shrink flex flex-col space-y-1">
                        <div className="text-base font-semibold m-0 mb-2">
                            {__('Enable Beta Version', 'uael')}
                        </div>
                        <div className="text-sm font-normal m-0">
                            {sprintf(
                                __(
                                    'Turn this on to get notified when a new beta version of %s is available. The beta version will not install automatically. You will need to install it manually. We recommend using it only in a test environment.',
                                    'uael'
                                ),
                                uaelSettingsData.plugin_name
                            )}
                        </div>
                        <div className="text-sm font-normal mt-2 pt-2">
                            {__('Please read ', 'uael')}
                            <a
                                href="https://ultimateelementor.com/docs/enabling-automatic-beta-updates-for-uael/?utm_source=uael-pro-dashboard&utm_medium=uael-menu-page&utm_campaign=uael-pro-plugin"
                                className="uael-link-color no-underline uael-remove-ring"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {__('this article', 'uael')}
                            </a>
                            {__(' to know more.', 'uael')}
                        </div>
                    </Container.Item>
                    <Container.Item
                        className="shrink-0 p-2 flex space-y-6"
                        alignSelf="auto"
                        order="none"
                        style={{ marginTop: '40px' }}
                    >
                        <Switch
                            size="lg"
                            value={betaEnabled} // Set switch state
                            onChange={handleBetaSwitch} // Handle switch change
                        />
                    </Container.Item>
                </Container>
            </div>
        </>
    );
};

export default VersionControl;
